module.exports = __webpack_public_path__ + "static/img/IMG_0415.f3e368f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/news/IMG_0415.jpg
// module id = 79SQ
// module chunks = 1